import React from 'react';
import { Gift } from 'lucide-react';
import BotanicalBackground from './BotanicalBackground';

const GiftRegistry: React.FC = () => {
  return (
    <section id="regalos" className="relative py-20 px-4">
      {/* Usamos el fondo botánico específico optimizado para registry */}
      <div className="absolute inset-0 overflow-hidden">
        <BotanicalBackground section="registry" className="absolute h-full" />
      </div>
      
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <h2 className="text-4xl md:text-5xl font-parisienne text-forest mb-6">Mesa de Regalos</h2>
        <div className="w-24 h-0.5 bg-sage/30 mx-auto mb-12"></div>
        
        <div className="bg-cream/80 backdrop-blur-md rounded-lg shadow-md p-8 md:p-12 mb-10">
          <div className="flex justify-center mb-8">
            <Gift size={40} className="text-forest/60" />
          </div>
          
          <p className="text-forest/90 mb-8 max-w-2xl mx-auto text-lg font-baskerville">
            Tu presencia es nuestro mejor regalo, pero si deseas obsequiarnos algo más, 
            aquí hay una opción.
          </p>
          
          <div className="mt-10">
            <div className="bg-cream/70 rounded-lg p-8 shadow-sm max-w-lg mx-auto">
              <h3 className="text-3xl mb-6 font-baskerville text-forest">Transferencia Bancaria</h3>
              <div className="space-y-3 text-forest/90 text-lg font-baskerville">
                <p>Banco Pichincha</p>
                <p>Cuenta de Ahorros: 5619558200</p>
                <p>A nombre de: Carlos Morochz</p>
                <p>Cédula: 1712447992</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GiftRegistry;
